/** @default screen */
type InteropMode = "screen" | "full";

interface EmnsInterop {
    getAccessToken(): string | undefined;
    getUserId(): string | undefined;

    getMode?: () => InteropMode;
    getProfileOptions?: () => string;
    onProfileOptionClick?(id: string): void;

    draftDidCreate?(id: string): void;
    draftDidUpdate?(id: string): void;
    draftDidSend?(id: string): void;
    draftDidSchedule?(id: string): void;

    onFormDirtyStateChange?(isDirty: boolean): void;
    onToast?(level: "success" | "info" | "error", message: string): void;
}

declare global {
    interface Window {
        interop?: EmnsInterop;
    }
}

export function isEmbedded() {
    return !!window.interop && window.interop.getMode?.() != "full";
}
